if (!customElements.get('ck-gt-announcement-info')) {
  class CkAnnouncementInfo extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.ck-gt-announcement-info__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      const section = this.closest('.shopify-section');

      // Whole bar is clickable, incl. the page-width gutters
      (section || this).addEventListener('click', (event) => {
        if (this.dialog.contains(event.target)) return;
        this.dialog.open ? this.hide() : this.show();
      }, { signal });
      this.dialog.querySelectorAll('[data-ck-close]').forEach((el) => el.addEventListener('click', () => this.hide(), { signal }));

      if (Shopify.designMode && section) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target === section) this.show();
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.target === section) this.hide();
        }, { signal });
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.openController?.abort();
      document.documentElement.style.removeProperty('overflow');
    }

    show() {
      clearTimeout(this.closeTimer);

      if (!this.dialog.open) {
        this.dialog.style.setProperty('--ck-gt-ai-top', `${Math.max(0, this.getBoundingClientRect().bottom)}px`);
        this.dialog.show();
      }

      document.documentElement.style.overflow = 'hidden';
      this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.open && this.dialog.classList.add('is-active')));

      this.bindWhileOpen();
      this.dialog.querySelector('.ck-gt-announcement-info__panel')?.focus({ preventScroll: true });
    }

    // Non-modal dialog: no native ESC, so handle it while open
    bindWhileOpen() {
      this.openController?.abort();
      this.openController = new AbortController();
      document.addEventListener('keyup', (event) => event.code === 'Escape' && this.hide(), { signal: this.openController.signal });
    }

    hide() {
      if (!this.dialog.open) return;
      this.openController?.abort();
      if (this.dialog.contains(document.activeElement)) this.trigger.focus({ preventScroll: true });
      this.dialog.classList.remove('is-active');
      this.trigger.setAttribute('aria-expanded', 'false');

      const panel = this.dialog.querySelector('.ck-gt-announcement-info__panel');
      const duration = parseFloat(getComputedStyle(panel).transitionDuration) * 1000 || 0;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (this.dialog.classList.contains('is-active')) return;
        this.dialog.close();
        document.documentElement.style.removeProperty('overflow');
      }, duration);
    }
  }

  customElements.define('ck-gt-announcement-info', CkAnnouncementInfo);
}
